module.exports = __webpack_public_path__ + "static/agroforestry-mobile-b3b2db88756ecfc80dc34fdd80464340.svg";